import groq from "groq"

export const complaintOptionsProjection = () => groq`
  "id": _id,
  "rev": _rev,
  label,
  name
`
